import { makeAutoObservable } from 'mobx';

/**
 * Per-app metadata: the appId the wallet is operating for, its display name,
 * and the host page's origin. Set by `EmbedWallet` at the start of a session
 * via `wallet:hello` (Cycle 5). For standalone wallet UI sessions the appId
 * falls back to `scp-wallet`.
 *
 * Spec §2.3, §5.2 (AppContext shape).
 */
export interface AppContext {
  appId: string;
  name?: string;
  origin?: string;
}

const DEFAULT_APP_ID = 'scp-wallet';

export class AppContextStore {
  private _app: AppContext = { appId: DEFAULT_APP_ID };

  constructor() {
    makeAutoObservable(this);
  }

  get app(): AppContext {
    return this._app;
  }

  setApp(app: AppContext): void {
    this._app = { ...app };
  }

  reset(): void {
    this._app = { appId: DEFAULT_APP_ID };
  }
}
